/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/common';
import '../../common/currency';
import '../../payments/icc';
import '../../payments/reverse';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "VoidType": {
                "values": {
                  "DEFAULT_VOID_TYPE_DO_NOT_USE": 0,
                  "VOID_OTHER": 1,
                  "VOID_HUMAN_INITIATED": 2,
                  "VOID_CLIENT_INITIATED_TIMEOUT": 3,
                  "VOID_CLIENT_INITIATED_APP_TERMINATION": 4,
                  "VOID_SERVER_INITIATED_CONFLICT_RESOLUTION": 5,
                  "VOID_SERVER_INITIATED_TIMEOUT": 6,
                  "VOID_MERCHANT_INITIATED": 7,
                  "VOID_SUPPORT_INITIATED": 8,
                  "VOID_DELAY_CAPTURE_OVERDUE": 9,
                  "VOID_READER_INITIATED": 10,
                  "VOID_PAYMENTS_INITIATED_ORDER_REFUSED": 11
                }
              },
              "ReverseRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientPaymentKey": {
                    "type": "squareup.esperanto.common.ClientPaymentKey",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reverseUuid": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": "squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "iccData": {
                    "type": "squareup.payments.icc.ReverseRequestIccData",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includePaymentRecord": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "options": {
                    "type": "squareup.esperanto.common.ReverseOptions",
                    "id": 9,
                    "rule": "optional"
                  },
                  "voidType": {
                    "type": "squareup.esperanto.api.VoidType",
                    "id": 12,
                    "rule": "optional"
                  },
                  "clientRequestedAtMs": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "ReverseResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "error": {
                    "type": "squareup.payments.reverse.ReverseError",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentRecord": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.VoidType && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ReverseRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ReverseResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE VoidType @ squareup/esperanto/api/reverse.proto at 13:1
 */
export const VoidType = $root.lookupEnum('squareup.esperanto.api.VoidType').values;
/**
 * Request payload for Reverse (i.e. Void) request.
 * Either "payment_id" or "client_payment_key" is required
 * to identify the voided payment.
 *
 * SOURCE ReverseRequest @ squareup/esperanto/api/reverse.proto at 89:1
 */
export const ReverseRequest = $root.lookupType('squareup.esperanto.api.ReverseRequest');
fixType(ReverseRequest);
Builder.createAndAttachToType(ReverseRequest);
/**
 * SOURCE ReverseResponse @ squareup/esperanto/api/reverse.proto at 134:1
 */
export const ReverseResponse = $root.lookupType('squareup.esperanto.api.ReverseResponse');
fixType(ReverseResponse);
Builder.createAndAttachToType(ReverseResponse);